import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {AppProviders} from '@dofleini/security';
import * as AuthClient from '../services/AuthClient';
import {useMe} from '../hooks/useUsers';

const SecurityProvider = ({children}) => {
  const {data, isLoading, refetch, isStale} = useMe();

  return (
    <AppProviders user={data} isLoading={!data && isLoading}
      authClient={AuthClient}
      reload={refetch}
      isSettled={isStale}>
      {children}
    </AppProviders>
  );
};

export default memo(SecurityProvider);

SecurityProvider.propTypes = {
  children: PropTypes.any
};
